import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToasterManagerService {
  isBrowser = false;
  constructor(
    private readonly _toasterService: ToastrService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  show(message: string) {
    if (!this.isBrowser) return;
    return this._toasterService.show(message);
  }

  success(message: string) {
    if (!this.isBrowser) return;
    return this._toasterService.success(message);
  }

  error(message: string) {
    if (!this.isBrowser) return;
    return this._toasterService.error(message);
  }

  warning(message: string) {
    if (!this.isBrowser) return;
    return this._toasterService.warning(message);
  }

  info(message: string) {
    if (!this.isBrowser) return;
    return this._toasterService.info(message);
  }

  clear(toastId: number) {
    if (!this.isBrowser) return;
    this._toasterService.clear(toastId);
  }
}
